package com.essntl.features.authentication.domain.models

data class CheckModel(
    val state: State,
) {
    enum class State {
        NO_TENANT_FOUND,
        USER_NOT_FOUND,
        OTP_SENT
    }
}

